// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2tA68","content":"styles_content__Flf9I","checkbox":"styles_checkbox__3TbhO","checkboxLabel":"styles_checkboxLabel__3r58g"};